// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"baa9bc0f","195":"ff66be7b","453":"95ff71dd","644":"312df4a6","667":"be965478","774":"9c0f0b5f","804":"f876f68a"}[chunkId] + ".chunk.js";
};